module.exports = __webpack_public_path__ + "static/media/FilesProject.673d9734.svg";